import React from 'react';
import SectionTitle from '../UI/SectionTitle';
import ServiceItemTwo from './ServiceItemTwo';
import ServicesData from '../../data/Services/servicestwo';

import serviceTopBg from '../../assets/img/fun-fact-bg.jpg';

function ServicesTwo({ classes }) {
    return (
        <div className={`service-area-wrapper ${classes}`}>
            <style>
                {`
                .service-area-top:before {
                    background-color: #BB2649 !important;
                    border-color: #BB2649 !important;
                    color: #ffffff !important;
                }

                .service-item {
                    position: relative;
                    text-align: center;
                    overflow: hidden;
                }

                .service-item:hover {
                    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.26);
                }

                .service-item .service-content {
                    background-color: rgba(187, 38, 73, 0.9) !important; /* Dark red with 90% opacity */
                    transition: 0.4s;
                    left: -100%;
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 100%;
                }

                .service-item:hover .service-content {
                    left: 0;
                }
                `}
            </style>
            <div className="service-area-top" style={{ backgroundImage: `url("${serviceTopBg}")` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-xl-5 m-auto text-center">
                            <SectionTitle variant="light" title="Our Services" heading="" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-content-area">
                <div className="container">
                    <div className="row justify-content-center">
                        {ServicesData.map(service => (
                            <ServiceItemTwo
                                key={service.id}
                                id={service.id}
                                title={service.title}
                                text={service.shortDesc}
                                thumb={service.thumb}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServicesTwo;
